/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OdometerUnitTypeApiModel } from './odometer-unit-type';
import { FuelControllerPumpAuthorizeConfirmationApiModel } from './fuel-controller-pump-authorize-confirmation';
import { PriceMarginsApiModel } from './price-margins';
import { PriceTypeApiModel } from './price-type';
import { FuelControllerConfigurationApiModel } from './fuel-controller-configuration';
import { PriceTaxesApiModel } from './price-taxes';
import { FuelFillingTypeApiModel } from './fuel-filling-type';
import { FuelControllerTypeApiModel } from './fuel-controller-type';
import { FuelTankApiModel } from './fuel-tank';

export interface JobFuelApiModel {
  /**
   * AVI (automatic vehicle identification) Id value (optional)
   */
  avi_id?: string | null;
  /**
   * Fuel amount captured by check
   */
  captured_amount?: number | null;
  /**
   * Fuel price captured by check
   */
  captured_price?: number | null;
  /**
   * Fuel volume captured by check
   */
  captured_volume?: number | null;
  /**
   * Controller connection failed flag (Exists and set to true only if connection with controller failed)
   */
  connection_failed?: boolean | null;
  /**
   * Internal controller ID
   */
  controller?: string | null;
  controller_configuration?: FuelControllerConfigurationApiModel;
  /**
   * Controller Id
   */
  controller_id?: string | null;
  controller_type?: FuelControllerTypeApiModel;
  /**
   * Error message (Exists only if controller send error message)
   */
  error_message?: string | null;
  /**
   * Job money amount
   */
  filled_amount?: number | null;
  /**
   * Job filled volume
   */
  filled_volume?: number | null;
  /**
   * Filling preset dose in volume units (for preset type Volume) or in currency units (for preset type Amount)
   */
  filling_doze?: number | null;
  /**
   * Filling fuel price
   */
  filling_price?: number | null;
  /**
   * Filling price currency ISO code (Only if filling_price_type is \'currency\')
   */
  filling_price_currency?: string | null;
  filling_price_margins?: PriceMarginsApiModel;
  /**
   * Filling price special account Id (Only if filling_price_type is \'special-account\')
   */
  filling_price_special_account_id?: string | null;
  filling_price_taxes?: PriceTaxesApiModel;
  filling_price_type?: PriceTypeApiModel;
  /**
   * Filling price unit - quantity or currency ISO code (Only if filling_price_type is \'special-account\')
   */
  filling_price_unit?: string | null;
  filling_type?: FuelFillingTypeApiModel;
  /**
   * Goods code
   */
  goods_code?: string | null;
  /**
   * Goods title (optional)
   */
  goods_title?: string | null;
  /**
   * Internal grade ID / Grade number
   */
  grade?: string | null;
  /**
   * Grade Id
   */
  grade_id?: string | null;
  /**
   * Item amount
   */
  item_amount?: number | null;
  /**
   * Item code (optional)
   */
  item_code?: string | null;
  /**
   * Item price
   */
  item_price?: number | null;
  /**
   * Item quantity
   */
  item_quantity?: number | null;
  /**
   * Item title (optional)
   */
  item_title?: string | null;
  /**
   * Internal nozzle ID / Pump nozzle
   */
  nozzle?: string | null;
  /**
   * Nozzle Id
   */
  nozzle_id: string | null;
  /**
   * Odometer/engine hours value, up to two decimal digits (optional)
   */
  odometer?: number | null;
  odometer_unit?: OdometerUnitTypeApiModel;
  /**
   * Internal pump ID / Pump number
   */
  pump?: string | null;
  pump_authorize_confirmation?: FuelControllerPumpAuthorizeConfirmationApiModel;
  /**
   * Pump Id
   */
  pump_id?: string | null;
  /**
   * Fuel filling status
   */
  status?: JobFuelApiModelStatusEnum | null;
  /**
   * Internal tank ID / Tank number
   */
  tank?: string | null;
  tank_details?: FuelTankApiModel;
  /**
   * Tank Id
   */
  tank_id?: string | null;
  /**
   * Qr Code / Tag of vehicle or equipment value (optional)
   */
  vehicle_id?: string | null;
}
export enum JobFuelApiModelStatusEnum {
  WaitingForProcess = 'waiting-for-process',
  PumpIsOffline = 'pump-is-offline',
  PumpIsBusy = 'pump-is-busy',
  NozzleNotTakenUp = 'nozzle-not-taken-up',
  WrongNozzleTakenUp = 'wrong-nozzle-taken-up',
  ReadyForFilling = 'ready-for-filling',
  Filling = 'filling',
  FillingStopping = 'filling-stopping',
  FillingFinished = 'filling-finished',
  FillingFailed = 'filling-failed'
}
